<template>
    <div>
        <template v-for="section in sections">
            <div :class="{'card mb-3': (!section.base_section || section.base_section == '') || !baseSection}" v-if="(!section.base_section && !baseSection) || (baseSection != null && section.base_section == baseSection)">

                <div class="card-header"  v-if="section.section_name && (!section.base_section || !baseSection)">
                    <strong>{{ section.section_name }}</strong>
                </div>

                <div :class="{'card-body': (!section.base_section || section.base_section == '') || !baseSection}">
                    <template v-for="field in section.fields">
                        <h4 v-if="field.type == 'Heading' && !pdfView">{{ field.label }}</h4>

                        <p v-if="field.type == 'Paragraph' && !pdfView" :class="(field.color ? 'alert alert-'+field.color : null)" v-html="field.text"></p>

                        <div v-if="(field.type != 'Paragraph' && field.type != 'Heading') && (field.parent_field_id == null || (field.parent_field_id != null && field.value))" class="row mb-2">
                            <label :class="`${labelSize}`" class="mb-0">{{ field.label }}:</label>
                            <div :class="`${fieldSize}`">
                                <template v-if="field.type == 'Radio'">
                                    {{ field.options[field.value] }}
                                </template>

                                <template v-else-if="field.type == 'Checkbox' && field.value">
                                    <span v-for="(val, i) in field.value">
                                        <span v-if="i > 0">, </span>{{ field.options[val] }}
                                    </span>
                                </template>

                                <template v-else-if="field.type == 'Date'">
                                    {{ field.value | moment("MM/DD/YYYY") }}
                                </template>

                                <template v-else-if="field.type == 'Textarea'">
                                    <div v-html="field.value"></div>
                                </template>
                                <template v-else-if="field.type == 'Employee'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/employees/view/${field.value.EmployeeId}`" title="View Employee">{{ field.value.EmployeeNumber }} - {{ field.value.FirstName }} {{ field.value.LastName }}</router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'Equipment'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/equipment/view/${field.value.equipment_id}`" title="View Equipment">
                                            {{ field.value.equipment_type_name }} - {{ field.value.serial_number }} <span v-if="field.value.equipment_name">{{ field.value.equipment_name }}</span>
                                        </router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'Jobsite'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/jobsites/view/${field.value.JobsiteId}`" title="View Jobsite">{{ field.value.JobsiteNumber }} - {{ field.value.JobsiteName }}</router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'User'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/users/view/${field.value.UserId}`" title="View User">{{ field.value.FirstName }} {{ field.value.LastName }}</router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'File'">
                                    <template v-if="field.value != null">
                                        <template v-if="Array.isArray(field.value)">
                                            <div v-for="file in field.value">
                                                <a :href="`/files/download/${file.file_id}`" v-if="$root.downloadOnly(file.file_extension)" target="_blank" title="Download File in a New Tab">{{ file.file_name }}</a>
                                                <a :href="`/files/view/${file.file_id}`" v-else target="_blank" title="View File in a New Tab">{{ file.file_name }}</a>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <a :href="`/files/download/${field.value.file_id}`" v-if="$root.downloadOnly(field.value.file_extension)" target="_blank" title="Download File in a New Tab">{{ field.value.file_name }}</a>
                                            <a :href="`/files/view/${field.value.file_id}`" v-else target="_blank" title="View File in a New Tab">{{ field.value.file_name }}</a>
                                        </template>
                                    </template>
                                </template>
                                <template v-else-if="Array.isArray(field.value)" v-for="(val, key) in field.value">
                                    <span v-if="key > 0">, </span>{{ val }}
                                </template>
                                <template v-else>{{ field.value }}</template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            sections: {
                type: Array,
                required: true,
            },

            baseSection: {
                type: String,
                default: null,
            },

            labelSize: {
                type: String,
                default: 'col-md-3 col-12 text-md-right text-muted'
            },

            fieldSize: {
                type: String,
                default: 'col-md-9 col-12',
            },

            pdfView: {
                type: Boolean,
                default: false,
            }
        },

        data: function() {
            return {

            }
        },


        methods: {

        },

        mounted() {

        }
    }
</script>